import './Top100User.css'
// import './Top100User.scss'

type UserProps = {
  [key: string]: any;
}

type Top100UserProps = {
  users: UserProps[]
}

export default function Top100User(props: Top100UserProps) {
  const {
    users,
  } = props;
  console.log(`✅ users[0]`, users[0]);
  const styles = {
    width: 100,
    height: 100,
    borderRadius: 10,
    background: '#ccc',
    // boxSizing: 'border-box',
    border: '1px solid red',
  }
  return (
    <>
      {users.map((user, index) => {
        return(
          <div key={index + 1} className="user-box">
            <img src={user.avatar_url} alt="logo" style={styles}/>
            <span>No.{index + 1}</span>
            <span>{user.login}</span>
          </div>
        )
      })}
    </>
  );
}

